import { Component, Inject, OnInit } from '@angular/core';
import { BaseDatasourceComponent } from '../base-datasource/base-datasource.component';
import { CommonService, Shared } from '@rubii/frontend-common';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfigService } from '../../../services/config.service';
import { DatasourceConnectionComponent } from '../../datasource-connection/datasource-connection.component';
import { ClientService } from '../../../services/client.service';

@Component({
  selector: 'app-common-popup',
  templateUrl: './common-popup.component.html',
})
export class CommonPopupComponent extends BaseDatasourceComponent implements OnInit {

  platform: string;
  captionKey: string;
  captionSecret: string;
  connectFunction: (clientId: string, clientSecret: string) => Promise<0|string>;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private client: ClientService, private config: ConfigService, private snackBar: MatSnackBar, private dialogRef: MatDialogRef<DatasourceConnectionComponent>) {
    super();
    this.platform = data?.data?.platform || 'the platform';
    this.captionKey = data?.data?.key || 'Client ID';
    this.captionSecret = data?.data?.secret || 'Client Secret';
    this.connectFunction = data?.connectCallback || ((clientId: string, clientSecret: string) => 0);
  }

  ngOnInit() {
    this.connectionForm = new FormGroup({
      clientId: new FormControl('', [Validators.required]),
      clientSecret: new FormControl('', [Validators.required]),
    });
  }

  async connect() {
    if (this.connectionForm.valid) {
        const errorMessage = await this.connectFunction(this.connectionForm.controls.clientId.value, this.connectionForm.controls.clientSecret.value);
        if (!errorMessage) {
          this.openSnackBar(this.snackBar, 'Data source connected.', 'closed');
          this.dialogRef.close();
        } else {
          this.openSnackBarWarning(this.snackBar, errorMessage, 'closed')
        }
    }
  }
}
